var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { initLoadManagerActionSaga } from '../../root-modules/init-load-manager-module';
var WrappedContainer = /** @class */ (function (_super) {
    __extends(WrappedContainer, _super);
    function WrappedContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cardRef = createRef();
        _this.wasLazyLoaded = false;
        _this.initLazyLoading = function () {
            if (!_this.cardRef.current) {
                return;
            }
            var observer = new window.IntersectionObserver(
            // always one because triggeren only on our ONE component
            // 1 component per 1 observer
            function (_a) {
                var _b = __read(_a, 1), entry = _b[0];
                if (entry.isIntersecting && !_this.wasLazyLoaded) {
                    _this.props.initLoadManagerAction(_this.props.config);
                    _this.wasLazyLoaded = true;
                    if (_this.cardRef.current) {
                        observer.unobserve(_this.cardRef.current);
                    }
                }
            }, { threshold: 0.0000001 });
            observer.observe(_this.cardRef.current);
        };
        return _this;
    }
    WrappedContainer.prototype.componentDidMount = function () {
        this.initLazyLoading();
    };
    WrappedContainer.prototype.componentDidUpdate = function (prevProps) {
        try {
            var shouldRecall = this.props.shouldRecall({
                prevProps: prevProps,
                currentProps: this.props,
            });
            if (shouldRecall && this.wasLazyLoaded) {
                this.props.initLoadManagerAction(this.props.config);
            }
        }
        catch (error) {
            console.error('error in componentDidUpdate in InitLoadManagerViewportLoader', error);
        }
    };
    WrappedContainer.prototype.render = function () {
        // span - to have an inline element to measure children's height
        return React.createElement("span", { ref: this.cardRef }, this.props.children);
    };
    return WrappedContainer;
}(Component));
export { WrappedContainer };
var mapDispatchToProps = {
    initLoadManagerAction: initLoadManagerActionSaga,
};
export var InitLoadManagerViewportLoader = connect(null, mapDispatchToProps)(WrappedContainer);
